import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { AlertConfigurationStatus } from '../../models/alert-configuration';
import { AlertService } from '../../services/alert.service';
import { DateTimeService } from '../../../shared/datetime/datetime.service';
import { Router, RouterLink } from '@angular/router';
import { GenericModalService, ModalSettingsTemplate } from '../../../shared/generic-modal/generic-modal.service';
import { AlertConfigurationHistoryDialogComponent } from '../alert-configuration-history-dialog/alert-configuration-history-dialog.component';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../../shared/grid/biz-grid.directive';
import { DxoEditingModule, DxoColumnFixingModule, DxiColumnModule, DxiButtonModule } from 'devextreme-angular/ui/nested';
import { BizUserColumnDirective } from '../../../shared/grid/biz-grid-user.directive';
import { BizDateColumnDirective } from '../../../shared/grid/biz-grid-date.directive';
import { DxTemplateModule } from 'devextreme-angular/core';
import { ChangeLogLinkComponent } from '../../../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../../../shared/change-log/change-log-link-entity/change-log-link-entity.directive';
import { StatusTrafficLightComponent } from '../../../shared/status-traffic-light/status-traffic-light.component';
import { NotificationTypeViewerComponent } from '../../../shared/notification-type-viewer/notification-type-viewer.component';
import { BizGridFiltervalues } from 'src/app/shared/grid/biz-grid-filtervalues';

@Component({
    selector: 'app-alert-status-grid',
    templateUrl: './alert-status-grid.component.html',
    styleUrls: ['./alert-status-grid.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxDataGridModule, BizDataGridDirective, DxoEditingModule, DxoColumnFixingModule, DxiColumnModule, BizUserColumnDirective, BizDateColumnDirective, DxiButtonModule, DxTemplateModule, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, StatusTrafficLightComponent, NotificationTypeViewerComponent, RouterLink]
})
export class AlertStatusGridComponent {

    @Input() items: AlertConfigurationStatus[] = [];
    @Output() selectedAlertConfigurationChange: EventEmitter<AlertConfigurationStatus[]> = new EventEmitter<AlertConfigurationStatus[]>();

    constructor(
        private alertService: AlertService,
        private router: Router,
        private modalService: GenericModalService,
        public bizGridFiltervalues: BizGridFiltervalues,
        public dateTimeService: DateTimeService) {
    }

    onRowDblClick(e: any): void {
        this.router.navigate(['/distribution/result/details', {distributionIds: e.data.DistributionId}]);
    }

    selectionChanged(e: any): void {
        this.selectedAlertConfigurationChange.emit(e.selectedRowsData);
    }

    alertStatusTooltip(latestAlertStatus: string): string {
        return this.alertService.getAlertStatusTooltip(latestAlertStatus);
    }

    async showHistoryDialog(alertConfigurationId: number): Promise<void> {
        const alertEvents = await this.alertService.getAlertEventsForAlertConfiguration(alertConfigurationId);

        const componentData = {
            alertEvents
        };

        try {
            await this.modalService.openComponent(AlertConfigurationHistoryDialogComponent, componentData, new ModalSettingsTemplate('lg', 'static'));
        } catch (err) {

        }
    }
}
